import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';

@Component({
  selector: 'roar-official-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './roar-official-signature.component.html',
  styleUrl: './roar-official-signature.component.css'
})
export class RoarOfficialSignatureComponent implements OnInit, OnChanges {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection4 = new EventEmitter<any>();

  roarSignatureForm: FormGroup = new FormGroup([]);
        
  currentDate = new Date();
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    private contactsService: ContactsService,
    private route: ActivatedRoute,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();
    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roarAssignmentFormData'] && this.roarAssignmentFormData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.roarSignatureForm = new FormGroup({
      user_signature_name: new FormControl('', Validators.required),
    });
  }
  
  saveRoarSignature(): void {
    if (this.roarSignatureForm.valid) {
        this.onSaveSection4.emit(this.roarSignatureForm.value);
    }
  }

}
